module.exports = __webpack_public_path__ + "static/media/bedrooms.ec6313b9.png";